import { ActionSubTypes } from '../../actions/ActionSubTypes';

export interface ICommonPageConstants {
  uid: string;
  header: {
    isDashboard: boolean;
    profileLink: string;
    title: string;
  };
  footer: {
    data: { text: string; iconClass: string; link: string }[];
  };
}

export const CommonPageConstants: ICommonPageConstants = {
  uid: ActionSubTypes.PAGE_NONEXISTS,
  header: {
    profileLink: '/kisisel',
    title: 'OYAK Gayrimenkul Faaliyetleri',
    isDashboard: true, // dashboardda, header içindeki geri dönüş oku gösterilmeyecek.
  },
  footer: {
    data: [
      {
        text: 'Anasayfa',
        iconClass: 'icon-home',
        link: '/dashboard',
      },
      {
        text: 'Harita',
        iconClass: 'icon-map',
        link: '/harita',
      },
      {
        text: 'Arama',
        iconClass: 'icon-seach',
        link: '/sorgula',
      },
      {
        text: 'OYAK',
        iconClass: 'icon-oyak',
        link: '/oyak',
      },
    ],
  },
};
